const en = {
  salePrice: "Sales price",
  maPrice: "Total Material Price",
  finallyPrice: "Profit",
  purePrice: "Net profit",
  priceCheck: "Cost Accounting",

  save: 'Save',
  saveSuccess: 'Accounting data has been updated',
  saveError: 'Accounting data update failed',
  saveTip: 'Confirm Save',
  saveTipContent: 'Save the modified discounts and commission rates?',
  costUpdate: 'Cost accounting data has been changed',
  costUpdateTip: 'Are you sure you want to abandon the changes?'
};

export default en;